module.exports = __webpack_public_path__ + "static/media/AG.7e594a00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AG.svg
// module id = 2096
// module chunks = 7